<template>

  <div v-if="stoneTypes && stoneTypes.length > 0" class="grow flex w-full text-sm">
    <div class="relative bg-gray-100 p-1 rounded-xl flex w-full shadow-inner">
      <!-- Sliding Background -->
      <div
          class="absolute top-1 bottom-1 bg-white rounded-lg shadow-sm transition-all duration-300 ease-out transform"
          :style="sliderStyle"
      ></div>

      <!-- Buttons -->
      <button
          type="button"
          class="relative min-w-0 flex-1 flex cursor-pointer items-center justify-center gap-2 transition-colors duration-200 z-10 min-h-11 px-2 py-1.5 text-sm font-light rounded-lg disabled:opacity-40 disabled:cursor-not-allowed focus-visible:outline-gray-700"
          :class="isStoneTypeActive('earth') ? 'bg-brand-main rounded-lg text-white' : 'text-gray-500 hover:text-gray-700'"
          :aria-pressed="isStoneTypeActive('earth')"
          :disabled="!hasStoneType('earth')"
          @click="setStoneType('earth')"
      >
        {{ $t(pageStr + '.natural_diamond') }}
      </button>

      <!-- Middle Ampersand -->
      <div v-if="bothActive" class="absolute inset-0 flex items-center justify-center z-20 pointer-events-none">
        <div class="bg-white rounded-full w-8 h-8 flex items-center justify-center shadow-md text-brand-main font-bold text-lg border-2 border-brand-main">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
          </svg>
        </div>
      </div>

      <button
          type="button"
          class="relative min-w-0 flex-1 flex cursor-pointer items-center justify-center gap-2 transition-colors duration-200 z-10 min-h-11 px-2 py-1.5 text-sm font-light rounded-lg disabled:opacity-40 disabled:cursor-not-allowed focus-visible:outline-gray-700"
          :class="isStoneTypeActive('lab') ? 'bg-brand-main rounded-lg text-white' : 'text-gray-500 hover:text-gray-700'"
          :aria-pressed="isStoneTypeActive('lab')"
          :disabled="!hasStoneType('lab')"
          @click="setStoneType('lab')"
      >
        {{ $t(pageStr + '.lab_diamond') }}
      </button>
    </div>
    <info-modal id="stoneType" :value="isStoneTypeActive('earth') ? 'earth' : 'lab'"/>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import InfoModal from "@/components/info/infoModal.vue";

const props = defineProps(["stoneTypes"]);
const emit = defineEmits(['patch'])
const pageStr = "components.itemV2.itemV2StoneType"

const bothActive = computed(() => isStoneTypeActive('earth') && isStoneTypeActive('lab'));

const activeIndex = computed(() => {
  if (bothActive.value) return -1;
  if (isStoneTypeActive('earth')) return 0;
  if (isStoneTypeActive('lab')) return 1;
  return -1;
});

const sliderStyle = computed(() => {
  if (activeIndex.value === -1) return { display: 'none' };

  const width = 50;
  const left = activeIndex.value * width;

  return {
    width: `calc(${width}% - 4px)`,
    left: `calc(${left}% + 2px)`,
  };
});

const isStoneTypeActive = (stoneType: string) => {
  for (const variantDataIdx in props.stoneTypes) {
    for (const variantDataValueIdx in props.stoneTypes[variantDataIdx].values) {
      if (
          props.stoneTypes[variantDataIdx].values[variantDataValueIdx].idx == stoneType &&
          props.stoneTypes[variantDataIdx].values[variantDataValueIdx].match == true
      ) {
        return true
      }
    }
  }
  return false
}

const hasStoneType = (stoneType: string) => (props.stoneTypes || []).some((variant: any) =>
    (variant.values || []).some((value: any) => value.idx === stoneType)
);

const setStoneType = (stoneType: string) => {
  const actionIdxs = []
  for (const variantDataIdx in props.stoneTypes) {
    for (const variantDataValueIdx in props.stoneTypes[variantDataIdx].values) {
      if (
          props.stoneTypes[variantDataIdx].values[variantDataValueIdx].idx == stoneType
      ) {
        actionIdxs.push(props.stoneTypes[variantDataIdx].idx)
      }
    }
  }

  if (!actionIdxs.length) return;

  emit('patch', {
    "action": actionIdxs,
    "value": stoneType,
    "certificated_diamond": 0
  })
}

</script>
